import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-custom-select-featured-options',
    templateUrl: './custom-select-featured-options.component.html',
    styleUrls: ['./custom-select-featured-options.component.scss'],
    standalone: false
})
export class CustomSelectFeaturedOptionsComponent {
  @Input() showSeparator = true;
}
